import { StyleSheet, View } from 'react-native'

import { observer } from 'mobx-react-lite'
import { useStore } from '../../../models'

import Clockwise from './assets/Clockwise.svg'
import CounterClockwise from './assets/CounterClockwise.svg'
import { ReactNode } from 'react'
import { TableTourStep } from '../../../models/game/walkthrough/table-tour'

export const PointingLine = observer(({ children }: { children: ReactNode }) => {
  const {
    game: { currentStep, walkthroughType }
  } = useStore()

  if (walkthroughType !== 'TableTour' || !currentStep) return null

  const step = currentStep as TableTourStep
  if (!step.line) return <View style={styles.content}>{children}</View>

  const { line, marginBottom } = step

  const DirectedLine = line.type === 'clockwise' ? Clockwise : CounterClockwise

  return (
    <View
      style={[
        styles.content,
        { marginBottom, flexDirection: line.verticalPosition === 'top' ? 'column' : 'column-reverse', gap: 30 }
      ]}
    >
      <View
        style={{
          transform: [{ rotateZ: `${line.rotation}deg` }],
          marginLeft: line.horizontalPosition === 'right' ? '30%' : '-30%'
        }}
      >
        <DirectedLine />
      </View>
      {children}
    </View>
  )
})

const styles = StyleSheet.create({
  content: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    gap: 5,
    paddingHorizontal: 80
  }
})
